module.exports = __webpack_public_path__ + "static/img/17.169f546.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/17.png
// module id = ErIw
// module chunks = 0